var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0 mb-12",attrs:{"fluid":_vm.$vuetify.breakpoint.smAndUp,"min-height":"90vh"}},[_c('event-mosaic'),_c('EventNotToMiss'),_c('EventMostConsulted')],1)}
var staticRenderFns = []

export { render, staticRenderFns }